module.exports = __webpack_public_path__ + "img/badge_appstore@3x.cbccd48d.png";